module.exports = __webpack_public_path__ + "static/media/small_gold.d18e7bec.png";